"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var react_dom_1 = require("react-dom");
var utils_1 = require("../utils");
var react_css_themr_1 = require("@vidazoo/react-css-themr");
var Portal_1 = require("../base/Portal");
function createFactory(identifier, draggableTheme) {
    return function draggable(WrappedComponent, options) {
        if (options === void 0) { options = {}; }
        var Draggable = /** @class */ (function (_super) {
            tslib_1.__extends(Draggable, _super);
            function Draggable(props, context) {
                var _this = _super.call(this, props, context) || this;
                _this.onMouseMove = function (e) {
                    var onDraggableMove = _this.props.onDraggableMove;
                    utils_1.pauseEvent(e);
                    var position = utils_1.getMousePosition(e);
                    _this.move(position);
                    onDraggableMove && onDraggableMove(e, react_dom_1.findDOMNode(_this.$el), position);
                };
                _this.onMouseUp = function (e) {
                    clearTimeout(_this.delayTimeout);
                    var onDraggableEnd = _this.props.onDraggableEnd;
                    if (_this.state.dragging) {
                        onDraggableEnd && onDraggableEnd(e, react_dom_1.findDOMNode(_this.$el));
                    }
                    _this.end(_this.getMouseEventMap());
                };
                _this.onMouseDown = function (e) {
                    utils_1.pauseEvent(e);
                    var mousePosition = utils_1.getMousePosition(e);
                    var rect = e.currentTarget.getBoundingClientRect();
                    _this.startingMouseX = mousePosition.x - rect.left;
                    _this.startingMouseY = mousePosition.y - rect.top;
                    utils_1.addEventsToDocument(_this.getMouseEventMap());
                    _this.delayTimeout = setTimeout(function () {
                        _this.start(mousePosition);
                    }, options.delay || 0);
                };
                _this.startingMouseX = 0;
                _this.startingMouseY = 0;
                _this.delayTimeout = null;
                _this.$el = null;
                _this.state = { dragging: false, x: 0, y: 0 };
                return _this;
            }
            Draggable.prototype.getMouseEventMap = function () {
                return {
                    mousemove: this.onMouseMove,
                    mouseup: this.onMouseUp
                };
            };
            Draggable.prototype.componentWillUnmount = function () {
                utils_1.removeEventsFromDocument(this.getMouseEventMap());
            };
            Draggable.prototype.start = function (position) {
                var _this = this;
                var onDraggableStart = this.props.onDraggableStart;
                this.setState({ dragging: true, x: position.x, y: position.y }, function () {
                    onDraggableStart && onDraggableStart(react_dom_1.findDOMNode(_this.$el));
                });
            };
            Draggable.prototype.move = function (position) {
                this.setState({ x: position.x, y: position.y });
            };
            Draggable.prototype.end = function (events) {
                utils_1.removeEventsFromDocument(events);
                if (this.state.dragging) {
                    this.setState({ dragging: false });
                }
            };
            Draggable.prototype.render = function () {
                var _this = this;
                var _a;
                var _b = this.props, theme = _b.theme, onDraggableStart = _b.onDraggableStart, onDraggableMove = _b.onDraggableMove, onDraggableEnd = _b.onDraggableEnd, others = tslib_1.__rest(_b, ["theme", "onDraggableStart", "onDraggableMove", "onDraggableEnd"]);
                var _c = this.state, dragging = _c.dragging, x = _c.x, y = _c.y;
                var wrapperElementProps = {
                    onMouseDown: this.onMouseDown
                };
                var wrapperStyle = {};
                var classes = classnames_1.default(theme.draggable, (_a = {},
                    _a[theme.dragging] = dragging,
                    _a));
                if (dragging) {
                    wrapperStyle.top = y - this.startingMouseY;
                    wrapperStyle.left = x - this.startingMouseX;
                    wrapperStyle.position = "fixed";
                    wrapperStyle.cursor = "move";
                }
                var wrapperComponentProps = tslib_1.__assign({}, others, { ref: function (el) { return _this.$el = el; } });
                var wrapper = (React.createElement("div", tslib_1.__assign({}, wrapperElementProps, { style: wrapperStyle, className: classes }),
                    React.createElement(WrappedComponent, tslib_1.__assign({}, wrapperComponentProps))));
                return dragging
                    ? React.createElement(Portal_1.default, null, wrapper)
                    : wrapper;
            };
            return Draggable;
        }(React.Component));
        return react_css_themr_1.themr(identifier, draggableTheme)(Draggable);
    };
}
exports.default = createFactory;
